import React from 'react';
import styled from "styled-components";
import logo from '../imgs/logosinfondo.png';
import descarga from '../imgs/descarga.png';
import qr from '../imgs/qr.png';
import fondoMobile from "../imgs/fondoMobile.jpg"
import logoPie from '../imgs/logoPie.png';
import fondoVideo from '../imgs/fondo-banner.mp4'
import videoPoster from "../imgs/bg-video.jpg"
import IngresoPanel from "./Login.jsx"
import {mobile} from  "../services/services.js"
import { useEffect, useState } from 'react';



const PanInicial=styled.div`
	position:relative;
	display:flex;
	align-items:center;
	min-width: auto;
	width: 100%;
	height:100vh
`;

const ImgStyle=styled.img`
	width:8vw;
	min-width:90px;
	position:absolute;
	top:1%;
	left:1%;
`;

const ContenedorVid=styled.div`
	position:relative;
	width:100vw;
	height:83vh;
	min-height:500px;
	display:flex;
	align-items:center
`;
const VideoLogin=styled.video`
	width: 100%;
	height:79vh;
	min-height:500px;
	object-fit: cover;
	overflow: clip;
`;

const MesaggeContainer=styled.div` 
	display:flex;
	text-align:center;
	flex-direction:column;
	font-family: 'Poppins', sans-serif;
	width:59vw;
	position:absolute;
	top : 25vh;
	left:7vw;
	align-items:center;
	@media (max-width:800px){
	        display:none};
	@media (max-height:400px){
	          display:none}

  `;


const Mesagge1=styled.div` 
  color: white;
  font-size:56px;
  filter: drop-shadow(0 2px 5px rgba(0, 0, 0, 0.7)); 
  `;


const Mesagge2=styled.div` 
	font-size:40px;
	color:#09b5c1;
	filter: drop-shadow(0 2px 5px rgba(0, 0, 0, 0.7));
	@media (max-width:910px){
	         display:none}
	
	;`

 const ButonDescarga=styled.a`
 color:black;
 	font-size:40px;
 	margin:15px;
 	border-radius:8px;
 	border:none;
 	background-color:yellow;
 	padding:10px;
 	text-decoration: none;
 	transition:all 200ms;
 :visited{text-decoration: none};
 &:hover{
 		background-color:#09b5c1;
 		color:white
 	}
 `;


const CubiertaVideo=styled.div`        
  background-image: linear-gradient(320deg, #138082 45%, #02263c -70%);
  opacity: 0.5;
  left: 0;
  width: 100%;
  height:95%;
  min-height:500px;
  position: absolute;
`;

const IngresoContainer=styled.div`
	position: absolute;
	right:10%
`;

const IngresoContainerMobile=styled.div`
	width:100%;
	height:100%;
	display:flex;
	align-items:center;
	justify-content:center;
	background-image: url(${fondoMobile});
	background-size:cover
`;

const PieInfo=styled.div`
	width: 100vw;
	display: flex;
	justify-content: center;
	align-items: center;
	text-align:center;
	position: absolute;
	bottom: 0px;
	font-size:15px;
	z-index: 5;
	color: #033953;
	min-height:80px;
 	@media (max-width:500px){
	          font-size:10px}
`;


const PieLinks=styled.a`
	text-decoration: none;
	:visited{text-decoration: none}
`;

const ImgPie=styled.img`
	width:auto;
	height:33px;
	display:block;
	padding:25px;
	filter: drop-shadow(0 2px 5px rgba(0, 0, 0, 0.7));
`;

const ContainerQR=styled.div`
	font-family: 'Poppins', sans-serif;
	position:absolute;
	height:160px;
	left:4vw;
	bottom:17vh;
	z-index:10;
	display:flex;
	flex-direction:column;
	align-items:center;
	color:white
`;

const QR=styled.img`
	height:150px;
	border:5px solid black;
	border-radius:25px;	
	filter: drop-shadow(0 2px 5px rgba(0, 0, 0, 0.7));
`;

const ContainerInstal=styled.div`
position:absolute;
top:5vh;
right:0vw;
background-color:#09b5c1;
color:white;
width:150px;
height:40px;
display:flex;
justify-content:center;
align-items:center;
border-radius : 6px 0px 0px 6px;
font-family: 'Poppins', sans-serif;

 `;


let espacioLink={ padding:"8px" }
 

export default function Ingreso(){
	const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showInstallPrompt, setShowInstallPrompt] = useState(false);

  useEffect(() => {
    window.addEventListener('beforeinstallprompt', (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setShowInstallPrompt(true);
    });
  }, []);

    const handleInstallClick = () => {
    	if (deferredPrompt) {
      		deferredPrompt.prompt();
      		deferredPrompt.userChoice.then((choiceResult) => {
        			if (choiceResult.outcome === 'accepted') {
          					console.log('User accepted the install prompt');
        			} else {
          					console.log('User dismissed the install prompt');
        			}
        			setDeferredPrompt(null);
        			setShowInstallPrompt(false);
      		});
    	}
  	};

	//let isLogin=""+useSelector(state=>state.isloguin);	

	//React.useEffect(()=>{ if(isLogin==="true" ){ navigate("./Home/tutoriales/basico")}},[isLogin,navigate]);	

  	let obtenerAño=()=>{
  		let  d = new  Date();
  		let  n = d.getFullYear();
  		return  n;
		}

	return(
	<PanInicial> 
		{mobile()?
			<div>
					{showInstallPrompt?
									<ContainerInstal onClick={handleInstallClick}>
										<b>Instalar</b>
										<img src={descarga} alt="logo descarga" height="14" hspace="6" align="center"  />
									</ContainerInstal>
						:null}
			</div>:
			<ContainerQR>
						<QR src={qr} /><div><b>en tu movil</b></div>
			</ContainerQR>}
		
	    
	   <a  href ="https://www.farmasis.site" target="blank"> <ImgStyle src={logo} alt="logo farmasis"/></a>
		
	    	
	  {mobile()?null:<div>  	 

	   	<ContenedorVid>			
		    <CubiertaVideo/>
		    <VideoLogin src={fondoVideo} muted autoPlay loop poster={videoPoster}/>		 

		    {showInstallPrompt?
		    	<MesaggeContainer>
						<Mesagge1><b>Descarga e instala en tu PC</b></Mesagge1>
						<Mesagge2>
							Farmasis Capacitaciones
						<ButonDescarga  onClick={handleInstallClick}><b>Instalar</b></ButonDescarga>		
						</Mesagge2>
					</MesaggeContainer>:	

					<MesaggeContainer>
						<Mesagge1><b>Gracias por descargar</b></Mesagge1>
						<Mesagge2>
							Farmasis Capacitaciones							
						</Mesagge2>
					</MesaggeContainer>}
			</ContenedorVid>	
		</div>}
		
		{mobile()?
		<IngresoContainerMobile>
			<IngresoPanel />
		</IngresoContainerMobile>:
		<IngresoContainer>
				<IngresoPanel />
		</IngresoContainer>}

		<PieInfo>
				{mobile()?null:
				<div>Powered by:
					<ImgPie src={logoPie} alt="logo cfc"/>
				</div>}
				<div> Copyright © 2015 - {obtenerAño()}     
					<PieLinks style={espacioLink} href ="https://www.farmasis.site/farmasis/index.html" target="blank" > Farmasis </PieLinks>
		 			 Soporte -
					<PieLinks style={espacioLink}  href ="https://wa.me/51985862693?text=Hola, quisiera informacíon sobre el soporte de farmasis" target="blank" > 985862693  </PieLinks>
					/Postventa - 
					<PieLinks style={espacioLink}  href ="https://wa.me/51980447009?text=Hola, quisiera informacíon sobre el siatema de ventas para farmacias" target="blank" > 980447009  </PieLinks>
		 		</div> 	
		</PieInfo>
			
		
	</PanInicial>)

}